import numeral from "numeral";

export const percentFormatter = v => `${numeral(v).format("(0,0.[0])")}%`;

export const dollarFormatter = v => numeral(v).format("($0,0)");

export const numberFormatter = v => numeral(v).format("(0,0.[0])");

export function number(amount) {
  if (amount === undefined) {
    return "-";
  }
  if (isNaN(amount)) {
    return amount;
  }
  return numberFormatter(amount);
}

export function dollar(amount) {
  if (amount === undefined) {
    return "-";
  }
  return dollarFormatter(amount);
}

export function percent(amount) {
  if (amount === undefined) {
    return "-";
  }
  return percentFormatter(amount);
}

export function numberAndPercent(volumeAmount, percentAmount) {
  if (volumeAmount === undefined || percentAmount === undefined) {
    return "-";
  }
  return `${numberFormatter(volumeAmount)} (${percentFormatter(
    percentAmount
  )})`;
}

export function dollarAndPercent(volumeAmount, percentAmount) {
  if (volumeAmount === undefined || percentAmount === undefined) {
    return "-";
  }
  return `${dollarFormatter(volumeAmount)} (${percentFormatter(
    percentAmount
  )})`;
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatsTooltip/format.js